//#region src/framework/utils/format-date/format-date.ts
/**
* Formats input to localized date.
* @param {Date | number} date - Date to be converted. This parameter may be given in either a Date object or as milliseconds in number format.
* @param {Intl.DateTimeFormatOptions} [options] - Optional. Date Time Format options, For more information, see [MDN - Intl - DateTimeFormat()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat).
* @param {Intl.LocalesArgument} [locale] - Optional. Locale options, For more information, see [MDN - Intl - locales argument](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
* @returns {string | undefined} This function returns a formatted date string. If locale or options are invalid, it will return undefined but produce a console error.
*/
const formatDate = (date, options, locale = "en-US") => {
	try {
		return new Intl.DateTimeFormat(locale, options).format(date);
	} catch {
		console.error(`Could not parse date: ${date} for locale: ${locale}`);
	}
};

//#endregion
export { formatDate };